<template>
  <div>
    <span class="headline pb-3" v-if="showHeader" style="display:block;">{{$t('pricelist.title')}}</span>
    <div style="white-space: pre-wrap;">{{$t('pricelist.description')}}</div>
    <v-container pa-0>
      <v-row>
        <v-col cols="12" md="6">
          <v-card>
            <v-card-title>{{$t('premium.basic')}}</v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col>{{$t('premium.no-advertising')}}</v-col>
                  <v-col cols="3" class="text-center">-</v-col>
                </v-row>
                <v-row>
                  <v-col>{{$t('premium.max-competitions-per-type')}}</v-col>
                  <v-col cols="3" class="text-center">1</v-col>
                </v-row>
                <v-row>
                  <v-col>{{$t('premium.publish-own-competitions-under-usercups')}}</v-col>
                  <v-col cols="3" class="text-center">-</v-col>
                </v-row>
                <v-row>
                  <v-col>{{$t('premium.competitions-with-checkin')}}</v-col>
                  <v-col cols="3" class="text-center">-</v-col>
                </v-row>
                <v-row>
                  <v-col>{{$t('premium.support-your-home-club-and-fc-fairplay')}}</v-col>
                  <v-col cols="3" class="text-center">-</v-col>
                </v-row>
                <v-row>
                  <v-col>{{$t('premium.extended-profile')}}</v-col>
                  <v-col cols="3" class="text-center">-</v-col>
                </v-row>
                <v-row>
                  <v-col>{{$t('premium.ko-with-third-place')}}</v-col>
                  <v-col cols="3" class="text-center">-</v-col>
                </v-row>
                <v-row>
                  <v-col>{{$t('premium.spectator-option')}}</v-col>
                  <v-col cols="3" class="text-center">-</v-col>
                </v-row>
                <v-row>
                  <v-col>{{$t('premium.league-one-round')}}</v-col>
                  <v-col cols="3" class="text-center">-</v-col>
                </v-row>
                <v-row>
                  <v-col>{{$t('gameHistory.title')}}</v-col>
                  <v-col cols="3" class="text-center">
                    <v-icon class="advantage">mdi-check</v-icon>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="6">
          <v-card>
            <v-card-title>
              {{$t('premium.premium')}}
              <v-icon class="premium-icon" color="var(--v-accent-lighten4)">mdi-star-circle-outline</v-icon>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col>{{$t('premium.no-advertising')}}</v-col>
                  <v-col cols="3" class="text-center">
                    <v-icon class="advantage">mdi-check</v-icon>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>{{$t('premium.max-competitions-per-type')}}</v-col>
                  <v-col cols="3" class="advantage text-center">100</v-col>
                </v-row>
                <v-row>
                  <v-col>{{$t('premium.publish-own-competitions-under-usercups')}}</v-col>
                  <v-col cols="3" class="text-center">
                    <v-icon class="advantage">mdi-check</v-icon>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>{{$t('premium.competitions-with-checkin')}}</v-col>
                  <v-col cols="3" class="text-center">
                    <v-icon class="advantage">mdi-check</v-icon>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>{{$t('premium.support-your-home-club-and-fc-fairplay')}}</v-col>
                  <v-col cols="3" class="text-center">
                    <v-icon class="advantage">mdi-check</v-icon>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>{{$t('premium.extended-profile')}}</v-col>
                  <v-col cols="3" class="text-center">
                    <v-icon class="advantage">mdi-check</v-icon>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>{{$t('premium.ko-with-third-place')}}</v-col>
                  <v-col cols="3" class="text-center">
                    <v-icon class="advantage">mdi-check</v-icon>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>{{$t('premium.spectator-option')}}</v-col>
                  <v-col cols="3" class="text-center">
                    <v-icon class="advantage">mdi-check</v-icon>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>{{$t('premium.league-one-round')}}</v-col>
                  <v-col cols="3" class="text-center">
                    <v-icon class="advantage">mdi-check</v-icon>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>{{$t('gameHistory.title')}}</v-col>
                  <v-col cols="3" class="text-center">
                    <v-icon class="advantage">mdi-check</v-icon>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    Mögliche Varianten:
                    <ul>
                      <li>Monatlich 1,99 &euro; ({{$t('common.incl-tax')}})</li>
                      <li>Quartalsweise 4,99 &euro; ({{$t('common.incl-tax')}})</li>
                      <li>Jährlich 14,99 &euro; ({{$t('common.incl-tax')}})</li>
                      <li>ODER: einmalig für einen Festpreis</li>
                    </ul>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "PricelistContent",
  props: {
    showHeader: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style scoped>
.advantage {
  font-weight: bold;
}
</style>
